export default "__VITE_ASSET__DkwodMek__"